import { render, staticRenderFns } from "./LogisticPartner.vue?vue&type=template&id=5e596d26&scoped=true"
import script from "./LogisticPartner.vue?vue&type=script&lang=js"
export * from "./LogisticPartner.vue?vue&type=script&lang=js"
import style0 from "./LogisticPartner.vue?vue&type=style&index=0&id=5e596d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e596d26",
  null
  
)

export default component.exports